export default __webpack_public_path__ + "static/media/ballicon.24d3316d.svg";